<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 11:02:02
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-26 11:45:00
-->

<script lang='ts' setup>
import { useGetRouteParam } from '@/shared/function'
import { topicBaseDetailApi, topicTemplateBaseDataApi, topicTemplatePageDataApi } from '@/server'
import type { TemplateTypeCode, TopicBaseResponse } from '~/server/types'
import topic1 from '@/components/topic/template/1.vue'
import topic2 from '@/components/topic/template/2.vue'
import topic3 from '@/components/topic/template/3.vue'
import { LOAD_STATE } from '~/shared/types'

const topicData = reactive<{
  bodyJson: Record<string, any>
  cssJson: Record<string, any>

}>({
  bodyJson: {},
  cssJson: {
    '--bodyBg': '#fff',
    '--subtitleColor': '#B3B7B8',
    '--titleBarColor': '#0066FF',
    '--titleColor': '#000',
    '--rbg': '#000',
  },

})

const templateList = {
  1: topic1,
  2: topic2,
  3: topic3,
}

const id = useGetRouteParam('id', '')
const templateTypeCode = ref<TemplateTypeCode>(1)
const topicDetail = ref<TopicBaseResponse>()
async function getDetail() {
  const loadState = ref(LOAD_STATE.INIT)
  const res = await useLoadState({
    key: 'topicBaseDetailApi',
    state: loadState,
    fn: () => topicBaseDetailApi(id.value),
  })
  const data = res!.data
  topicDetail.value = data
  templateTypeCode.value = data.templateTypeCode as TemplateTypeCode
  topicData.bodyJson = JSON.parse(data.bodyJson)
  const css = JSON.parse(data.cssJson)
  const formatCss = {
    '--bodyBg': css?.class_body_bg?.rgb || '#fff',
    '--subtitleColor': css?.font_color?.subtitleColor || '#B3B7B8',
    '--titleBarColor': css?.font_color?.titleBarColor || '#0066FF',
    '--titleColor': css?.font_color?.titleColor || '#000',
    '--rbg': css?.font_color?.rgb || '#000',
  }
  topicData.cssJson = formatCss
}
await getDetail()

useSite({
  title: computed(() => topicDetail.value?.title || '').value,
  description: computed(() => topicDetail.value?.description || '').value,
  keywords: [computed(() => topicDetail.value?.keywords || '').value],
})
</script>

<template>
  <component :is="templateList[templateTypeCode]" :style="topicData.cssJson" :body-json="topicData.bodyJson" :template-type-code="templateTypeCode" :topic-id="id" />
</template>

<style lang='scss' scoped></style>
